import { HorizontalLines, PlusIcon } from "@/frontend/shared/assets/icons";
import styles from "./NoPipelinesContent.module.scss";
import { Typography } from "@/frontend/shared/ui/Typography";
import { NormalButton } from "@/frontend/shared/ui/Button";
import { TPipeline } from "../../model/types/types";
import { useState } from "react";
import { AddPipelineModal } from "@/frontend/components/AddPipelineModal";

type NoPipelinesContentProps = {
  pipelinesData: TPipeline[];
  refetchPipelines: () => void;
  setCurrentPipeline: (pipeline: TPipeline) => void;
};
export function NoPipelinesContent({ pipelinesData, refetchPipelines, setCurrentPipeline }: NoPipelinesContentProps) {
  const [isAddPipelineModalOpen, setIsAddPipelineModalOpen] = useState(false);

  return (
    <div className={styles.container}>
      <HorizontalLines />
      <div className={styles.content}>
        <Typography variant="heading-6" color="greyscale800">
          No Pipelines Yet
        </Typography>
        <Typography variant="body-2" color="greyscale700">
          Create a new pipeline to start tracking your investment opportunities.
        </Typography>
        <NormalButton size="large" onClick={() => setIsAddPipelineModalOpen(true)}>
          <PlusIcon />
          Add Pipeline
        </NormalButton>
      </div>
      <AddPipelineModal
        isOpen={isAddPipelineModalOpen}
        onClose={() => setIsAddPipelineModalOpen(false)}
        pipelines={pipelinesData || []}
        triggerRefetch={refetchPipelines}
        setCurrentPipeline={setCurrentPipeline}
      />
    </div>
  );
}
